// extracted by mini-css-extract-plugin
export var confirmationHeader = "_wl-0";
export var confirmationIcon = "_wl-1";